import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
	modules: [Navigation, Autoplay],
	loop: true,
	centeredSlides: true,
	slidesPerView: 1.5,
  spaceBetween: 20,
	speed: 500,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
  },
	autoplay: {
		delay: 5000,
	},
	breakpoints: {
		768: {
			slidesPerView: 2.5,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3.5,
			spaceBetween: 30,
		}
	}
});